/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {BundlingSettingsDetailContract} from '../../../api/contracts/bundle-settings/bundling-settings-detail.contract';
import {BundlingSettingsDetailModel} from '../../models/bundling-settings-detail/bundling-settings-detail.model';

export class BundlingSettingsDetailMapper {

    static fromBundlingSettingsDetailContractToBundlingSettingsDetailModel(input: BundlingSettingsDetailContract):
            BundlingSettingsDetailModel {

        return {
                periodicity: input?.periodicity,
                periodDaysOffset: input?.periodDaysOffset,
                periodMaxBundles: input?.periodMaxBundles,
                bundleMaxValue: input?.bundleMaxValue,
                bundleCriterion: input?.bundleCriterion,
                bundlePositionCriterion: input?.bundlePositionCriterion,
                bundleMaxPositions: input?.bundleMaxPositions,
                lastChangedBy: input?.lastChangedBy,
                lastChangedOn: input?.lastChangedOn,
                currency: input?.currency,
                active: input?.active ?? false
            };
    }
}
